"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const BaseDocType = {
  // @required overwrite
  toFileText: function () {
    let {
      document: doc = ''
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return doc;
  },
  // @required overwrite
  getFileParams: docJson => {
    if (BaseDocType.isValidDocJson(docJson)) {
      const text = BaseDocType.toFileText(docJson);
      const name = BaseDocType.getFileName(docJson);
      const ext = BaseDocType.getFileExtension(docJson);
      const filename = [name, ext].filter(v => !!v).join('.');
      return {
        filename,
        content: text,
        mimeType: 'text/plain' // 'application/geo+json'
      };
    }
    return undefined;
  },
  // @required overwrite
  // eslint-disable-next-line no-unused-vars
  toDocJson: (fileName, content) => undefined,
  getDocType: function () {
    let docJson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return docJson.type;
  },
  getFileName: function () {
    let docJson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return docJson.fileName;
  },
  getFileExtension: function () {
    let docJson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return docJson.fileExtension;
  },
  getDocument: function () {
    let docJson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return docJson.document;
  },
  isValidDocJson: function () {
    let docJson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const requiredKeys = ['type', 'fileExtension', 'document'];
    const docKeys = Object.keys(docJson);
    return requiredKeys.every(k => docKeys.indexOf(k) > -1);
  }
};
var _default = BaseDocType;
exports.default = _default;